import _ from 'lodash';
import defaultState from './defaultState';
import * as types from '../../mutationTypes';

export default {
    /* eslint-disable no-param-reassign */
    [types.RESET_APPEARANCE](state) {
        state = _.deepClone(defaultState);
    },

    [types.SET_SIDE_NAV](state, value) {
        state.showSideNav = value;
    },

    [types.TOGGLE_SIDE_NAV](state) {
        state.showSideNav = !state.showSideNav;
    },

    [types.SET_SEARCH_PANEL](state, value) {
        state.showSearchPanel = value;
    },

    [types.SET_SNACKBAR_TEXT](state, value) {
        state.snackBar.text = value;
    },

    [types.SET_ALERT](state, value) {
        state.alert = value;
    },

    [types.RESET_ALERT](state) {
        state.alert = {
            type: null,
            message: null
        };
    },

    [types.SET_THEME](state, value) {
        state.theme = value;
    },

    [types.SET_DEFAULT_CURSOR](state) {
        state.cursor = 'default';
    },

    [types.SET_PROGRESS_CURSOR](state) {
        state.cursor = 'progress';
    },

    [types.SET_VIEW_TITLE](state, value) {
        state.viewTitle = value;
    },

    [types.SET_FULLSCREEN](state, value) {
        state.isFullScreen = value;
    },

    [types.SET_PREFERENCES_VIEW](state, value) {
        state.isPreferencesView = value;
    },

    [types.SET_ISMOBILE](state, value) {
        console.log('types.SET_ISMOBILE');
        state.isMobile = value;
    },
    /* eslint-enable no-param-reassign */
};



// WEBPACK FOOTER //
// ./src/store/modules/appearance/mutations.js